module.exports = __webpack_public_path__ + "static/scale-model-of-european-travel-in-glendale-california-10790cfe2ca7132efc8759a9c6b9d844.png";